module.exports = __webpack_public_path__ + "static/img/logo115.e7125e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo115.png
// module id = buTm
// module chunks = 1